import { PropertySaleListing } from '@guiker/property-sale-shared'
import { PropSharingListing } from '@guiker/propsharing-shared'

export const InvestmentListingType = {
  FractionalOwnershipListing: 'FractionalOwnershipListing',
  PropertySaleListing: 'PropertySaleListing',
}

type BaseInvestmentListing =
  | ({ type: 'FractionalOwnershipListing' } & PropSharingListing)
  | ({ type: 'PropertySaleListing' } & PropertySaleListing)

export type InvestmentListing = BaseInvestmentListing & { originalUpdatedAt?: string }
